module.exports = __webpack_public_path__ + "static/telegrotesknext-regular-webfont-4299caf94430a524e16ea1af39ad74ea.woff";